import { cn } from "@omni/utils/styles";

type DividerProps = {
    className?: string;
};

export const Divider = ({ className }: DividerProps) => {
    return (
        <div
            className={cn(
                "tw:block tw:bg-grey-light tw:h-px tw:my-2 tw:w-full",
                className
            )}
        />
    );
};
